import AttachFileIcon from "@mui/icons-material/AttachFile";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { axiosInstance } from "../../axiosInstance";
import {
  Button,
  Container,
  Paper,
  Stack,
  Typography,
  Box,
  Grid,
  Divider,
} from "@mui/material";
import { externalApiUrl } from "../../environment";
import "./LegalSummary.css";

function LegalSummary() {
  const [file, setFile] = useState(null);
  const [isShowSummary, setShowSummary] = useState(false);
  const [summaryResponse, setSummaryResponse] = useState("");

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.type === "application/pdf") {
      setFile(selectedFile);
      setSummaryResponse("");
      setShowSummary(true);
    } else {
      toast.warn("Please upload a PDF file only.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  const getSummaryResponse = async (type) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("file_type", type);

    try {
      const res = await axiosInstance.post(externalApiUrl + "summarize", formData);
      if (res) {
        setSummaryResponse(res.data?.summary);
      }
    } catch (err) {
      toast.error("Error While getting Summary.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  return (
    <Container maxWidth="lg">
      <Paper elevation={4} sx={{ padding: 4, borderRadius: 3, backgroundColor: "#f9f9f9", textAlign: "center", marginTop: 5 }}>
        <Typography variant="h4" fontWeight={700} gutterBottom>
          Contract Summary
        </Typography>
        <Divider sx={{ marginBottom: 3 }} />
        <Typography variant="h6" color="textSecondary" marginBottom={2}>
          Upload your document to generate a professional summary
        </Typography>
        <Grid container justifyContent="center">
          <Grid item>
            <Button
              variant="contained"
              component="label"
              startIcon={<AttachFileIcon />}
              sx={{ backgroundColor: "#1976d2", color: "#fff", paddingX: 3, paddingY: 1.5, fontSize: "1rem" }}
            >
              Choose File
              <input type="file" hidden onChange={handleFileChange} accept=".pdf,.doc,.docx" />
            </Button>
          </Grid>
        </Grid>
        {file && (
          <Box textAlign="left" marginTop={3} padding={2} borderRadius={2} sx={{ backgroundColor: "#e3f2fd" }}>
            <Typography variant="subtitle1" fontWeight={600}>File Details:</Typography>
            <Typography variant="body2"><strong>Name:</strong> {file.name}</Typography>
            <Typography variant="body2"><strong>Type:</strong> {file.type}</Typography>
            <Typography variant="body2"><strong>Size:</strong> {(file.size / 1024).toFixed(2)} KB</Typography>
          </Box>
        )}
      </Paper>

      {isShowSummary && (
        <Paper elevation={4} sx={{ padding: 4, borderRadius: 3, backgroundColor: "#f9f9f9", textAlign: "center", marginTop: 5 }}>
          <Typography variant="h5" fontWeight={600} marginBottom={2}>
            Summary Result
          </Typography>
          <Typography variant="body1" sx={{ fontSize: { xs: "1rem", sm: "1.25rem" }, fontWeight: 500, color: "#333", backgroundColor: "#e8f5e9", padding: 2, borderRadius: 2 }}>
            {summaryResponse || "Your summary will appear here."}
          </Typography>
          <Stack direction={{ xs: "column", sm: "row" }} spacing={3} justifyContent="center" mt={4}>
            <Button variant="contained" sx={{ backgroundColor: "#43a047", color: "#fff", paddingX: 3, paddingY: 1.5 }} onClick={() => getSummaryResponse("quick")}>
              Quick Summary
            </Button>
            <Button variant="contained" sx={{ backgroundColor: "#d32f2f", color: "#fff", paddingX: 3, paddingY: 1.5 }} onClick={() => getSummaryResponse("best")}>
              Best Summary
            </Button>
          </Stack>
        </Paper>
      )}
    </Container>
  );
}

export default LegalSummary;
